const x = ({ $useChips: e, $size: t = "small" }) => {
  const p = t === "medium" ? "9px" : "7px";
  return e ? "4px 28px 4px 10px" : `${p} 30px ${p} 12px`;
};
export {
  x as default
};
